import { initReadMore } from './read-more';

(function ($) {
  const navPrev = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>';
  const navNext = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>';

  $(function () {
    const $modal = $('#phent-quickview');
    if (!$modal.length) return;

    const $content = $modal.find('.phent-quickview__content');
    const ajaxUrl = $modal.data('ajax-url');

    function open() {
      $modal.removeClass('hidden').attr('aria-hidden', 'false');
      $('body').addClass('overflow-hidden');
      requestAnimationFrame(() => $modal.addClass('is-open'));
    }

    function close() {
      $modal.removeClass('is-open').attr('aria-hidden', 'true');
      $('body').removeClass('overflow-hidden');
      setTimeout(() => {
        $modal.addClass('hidden');
        $content.empty();
      }, 300);
    }

    $(document).on('click', '.quick-view', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const productId = $(this).data('product');
      $content.html(
        '<div class="grid grid-cols-2 max-md:grid-cols-1 animate-pulse">' +
          '<div class="aspect-[2/3] max-md:aspect-square bg-neutral-200"></div>' +
          '<div class="p-[30px] max-md:p-5">' +
            '<div class="h-7 w-4/5 bg-neutral-200 rounded"></div>' +
            '<div class="h-7 w-3/5 bg-neutral-200 rounded mt-2"></div>' +
            '<div class="h-[3px] w-[30px] bg-neutral-200 my-5"></div>' +
            '<div class="h-6 w-24 bg-neutral-200 rounded"></div>' +
            '<div class="mt-5 space-y-2">' +
              '<div class="h-3.5 w-full bg-neutral-100 rounded"></div>' +
              '<div class="h-3.5 w-11/12 bg-neutral-100 rounded"></div>' +
              '<div class="h-3.5 w-full bg-neutral-100 rounded"></div>' +
              '<div class="h-3.5 w-2/3 bg-neutral-100 rounded"></div>' +
            '</div>' +
            '<div class="mt-7 flex items-center gap-3">' +
              '<div class="h-11 w-28 bg-neutral-200 rounded"></div>' +
              '<div class="h-11 w-40 bg-neutral-200 rounded"></div>' +
            '</div>' +
            '<div class="mt-8 pt-4 border-t border-neutral-100 space-y-2">' +
              '<div class="h-3 w-32 bg-neutral-100 rounded"></div>' +
              '<div class="h-3 w-48 bg-neutral-100 rounded"></div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
      open();

      $.post(ajaxUrl, { action: 'phent_quickview', product: productId }, function (html) {
        if ($modal.hasClass('hidden')) return; // closed while loading
        $content.html(html);

        // Gallery slider when there is more than one image.
        const $gallery = $content.find('.quickview-gallery-slider');
        if ($gallery.children().length > 1 && $.fn.owlCarousel) {
          $gallery.addClass('owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            dots: false,
            nav: true,
            navText: [navPrev, navNext],
          });
        }

        // "Lees meer" toggle when the short description overflows its clamp.
        initReadMore($content[0]);

        // Variable products: boot the variation form.
        const $form = $content.find('.variations_form');
        if ($form.length && typeof $form.wc_variation_form === 'function') {
          $form.wc_variation_form();
        }
      });
    });

    $modal.on('click', '.phent-quickview__close', close);
    $modal.on('mousedown', function (e) {
      if (!$(e.target).closest('.phent-quickview__box').length) close();
    });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $modal.hasClass('is-open')) close();
    });
  });
})(jQuery);
